module.exports = __webpack_public_path__ + "static/media/Live-animals.a80ac86a.png";